import {useKeyboardEvent} from '@tempo/core';

type KeyboardOption = {key: string; shiftKey?: boolean; metaKey?: boolean};

const matchKeyboardEvent = (e: KeyboardEvent, option: KeyboardOption) => {
	return (
		e.key.toLowerCase() === option.key.toLowerCase() &&
		(typeof option.shiftKey === 'undefined' ||
			(typeof option.shiftKey !== 'undefined' &&
				e.shiftKey === option.shiftKey)) &&
		(typeof option.metaKey === 'undefined' ||
			(typeof option.metaKey !== 'undefined' && e.metaKey === option.metaKey))
	);
};

export const useMetaKeyboardSequence = (
	options: KeyboardOption | KeyboardOption[],
	callback: () => void,
	deps?: any[],
) => {
	useKeyboardEvent(e => {
		if (e.target !== document.body) {
			return;
		}

		if (
			(Array.isArray(options) && options.some(o => matchKeyboardEvent(e, o))) ||
			(!Array.isArray(options) &&
				matchKeyboardEvent(e, options as KeyboardOption))
		) {
			callback();
		}
	}, deps);
};

export default useMetaKeyboardSequence;
